import React, { useEffect, useRef } from 'react';
import { IntlProvider } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import classnames from 'classnames';

import { useShortSelector } from 'react-redux-app/lib/modules/core/hooks';
import { useCurrentLang, useShowKeys } from 'react-redux-app/lib/modules/i18n/hooks';

import { isDesktop } from '../../../core/utils/dom';

import themeContext from '../../../../themeContext';
import {
  SITE_ID__RIVCASH,
  SITE_ID__IXCASH,
  SITE_ID__ONLYFEETCASH,
} from '../../constants/rivcashClones';
import modalNameToComponentMap from '../../modalNameToComponentMap';

import { getTranslationsForCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';
import { getIsActive, getIsWebmasterLogged } from '../../../auth/selectors';
import { getRivcashCloneId } from '../../../init/selectors/initData';
import { getIsLeftMenuOpened } from '../../../ui/selectors';

import { ThemeProvider } from 'react-redux-app/lib/modules/core/components';
import ModalsStack from 'react-redux-app/lib/modules/modal/containers/ModalsStack';
import Footer from '../Footer';
import Header from '../Header';
import LeftMenu from '../LeftMenu';
import Notifications from '../Notifications';

import styles from './styles/index.css.json';


const siteIdToDirectoryMap = {
  [SITE_ID__RIVCASH]: 'rivcash',
  [SITE_ID__IXCASH]: 'ixcash',
  [SITE_ID__ONLYFEETCASH]: 'onlyfeetcash',
};

export default () => {
  const siteId = useShortSelector(getRivcashCloneId);
  const messages = useShortSelector(getTranslationsForCurrentLang);
  const isLeftMenuOpened = useShortSelector(getIsLeftMenuOpened);
  const isUserActive = useShortSelector(getIsActive);
  const isWebmasterLogged = useShortSelector(getIsWebmasterLogged);
  const lang = useCurrentLang();

  useShowKeys();

  const isFirstRenderCompleted = useRef(false);

  const directory = siteIdToDirectoryMap[siteId];

  useEffect(() => { isFirstRenderCompleted.current = true; }, []);

  return isWebmasterLogged && (
    <IntlProvider locale={lang} messages={messages}>
      <ThemeProvider theme={themeContext}>
        <div className={styles.layout}>
          <Helmet>
            <link rel="apple-touch-icon" sizes="57x57" href={`/static/images/favicons/${directory}/apple-icon-57x57.png`} />
            <link rel="apple-touch-icon" sizes="60x60" href={`/static/images/favicons/${directory}/apple-icon-60x60.png`} />
            <link rel="apple-touch-icon" sizes="72x72" href={`/static/images/favicons/${directory}/apple-icon-72x72.png`} />
            <link rel="apple-touch-icon" sizes="76x76" href={`/static/images/favicons/${directory}/apple-icon-76x76.png`} />
            <link rel="apple-touch-icon" sizes="114x114" href={`/static/images/favicons/${directory}/apple-icon-114x114.png`} />
            <link rel="apple-touch-icon" sizes="120x120" href={`/static/images/favicons/${directory}/apple-icon-120x120.png`} />
            <link rel="apple-touch-icon" sizes="144x144" href={`/static/images/favicons/${directory}/apple-icon-144x144.png`} />
            <link rel="apple-touch-icon" sizes="152x152" href={`/static/images/favicons/${directory}/apple-icon-152x152.png`} />
            <link rel="apple-touch-icon" sizes="180x180" href={`/static/images/favicons/${directory}/apple-icon-180x180.png`} />
            <link rel="icon" type="image/png" sizes="16x16" href={`/static/images/favicons/${directory}/favicon-16x16.png`} />
            <link rel="icon" type="image/png" sizes="32x32" href={`/static/images/favicons/${directory}/favicon-32x32.png`} />
            <link rel="icon" type="image/png" sizes="96x96" href={`/static/images/favicons/${directory}/favicon-96x96.png`} />
            <link rel="icon" type="image/png" sizes="192x192" href={`/static/images/favicons/${directory}/android-icon-192x192.png`} />
          </Helmet>

          <div className={styles.layout__header}>
            <Header />
          </div>

          {isUserActive && <LeftMenu />}

          <div
            className={classnames(
              styles.layout__contentAndFooterWrapper,
              {
                [styles.layout__contentAndFooterWrapper_menuOpened]:
                  isUserActive
                  && ((isLeftMenuOpened || !isFirstRenderCompleted.current) && isDesktop()),
              }
            )}
          >
            <div className={styles.layout__content}>
              <Notifications />
              <Outlet />
            </div>

            {isUserActive && (
              <div className={styles.layout__footer}>
                <Footer />
              </div>
            )}
          </div>

          <ModalsStack modalNameToComponentMap={modalNameToComponentMap} />
        </div>
      </ThemeProvider>
    </IntlProvider>
  );
};
